import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import scrollTo from 'simple-scrollTo';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-comments', {
  mixins: [eventListenerMixin],

  properties: {
    commentNewForm: String,
  },

  ready() {
    if (window.tower.me) {
      this.initComponents();
    } else {
      $(document).ready(this.initComponents.bind(this));
    }

    this.listenTo(this, 'click', this.handleReplyClick.bind(this));
  },

  initComponents() {
    window.tower.adjustAttachment(this);
    window.tower.adjustCommentEvents(this);
    window.tower.adjustCommentsLike(this);
    window.tower.foldComments(this);
    window.tower.foldEvents(this);
    window.tower.adjustReadableTime($(this));
    window.tower.adjustReadableDate($(this));
  },

  handleReplyClick(event) {
    const link = closest(event.target, '.comment .reply');
    if (!link) return;

    const commentNewForm = document.querySelector(this.commentNewForm);
    if (!commentNewForm) return;

    const replyContent = this.generateReplyContent({
      comment: closest(link, '.comment'),
      creatorGuid: link.dataset.creatorGuid,
      creatorUrl: link.dataset.creatorUrl,
      creatorName: link.dataset.creatorName,
    });
    commentNewForm.setContent(replyContent);
    commentNewForm.visible = true;

    scrollTo({
      target: $(commentNewForm),
      animation: false,
      cancelIfVisible: false,
    });
  },

  generateReplyContent({
    comment, creatorGuid, creatorName, creatorUrl,
  }) {
    const selection = document.getSelection();
    let selectedText = selection.toString();
    const selectionNode = selectedText ? selection.getRangeAt(0).startContainer : null;

    if (!selectedText || !comment.contains(selectionNode)) {
      selectedText = comment.querySelector('.comment-content').innerHTML
        .replace(/<blockquote data-reply="">.*?<\/blockquote>/ig, '');
      selectedText = window.tower.truncate($(`<div>${selectedText}</div>`).text(), 140);
    }

    return `
      <blockquote data-reply>
        <p>
          <a href="${creatorUrl}"
            data-member-guid="${creatorGuid}" data-mention>@${creatorName}</a>：<br/>
          ${window.tower.encodeHtml(selectedText)}
        </p>
      </blockquote>
      <p></p>
    `;
  },
});
